import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductListingComponent } from './components/product-listing/product-listing.component';
import { PromotionComponent } from './promotion.component';

const routes: Routes = [
  {
    path: 'All', component: PromotionComponent
  },
  {
    path: 'product/listing/:promotionid', component: ProductListingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PromotionRoutingModule { }
